module.exports = __webpack_public_path__ + "static/media/SimplyWallStLogo.a16c94cc.png";